import * as React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BarChartIcon from '@mui/icons-material/BarChart';
import DescriptionIcon from '@mui/icons-material/Description';
import LayersIcon from '@mui/icons-material/Layers';
import { AppProvider, Navigation, SessionContext, AuthenticationContext } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { PageContainer } from '@toolpad/core/PageContainer';
import {useLocation} from 'react-router-dom';
import Login from './pages/Login.tsx';
import {JSX, useEffect, useState} from "react";
import {Collapse, createTheme, IconButton} from "@mui/material";
import { supabase } from './components/supabaseClient.tsx';
import {ReactRouterAppProvider} from "@toolpad/core/react-router";
import { Outlet } from 'react-router';
import { Account } from '@toolpad/core/Account';
import Logout from '@mui/icons-material/Logout';
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import AlertTitle from "@mui/material/AlertTitle";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NotesIcon from '@mui/icons-material/Notes';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const NAVIGATION: Navigation = [
    {
        kind: 'header',
        title: 'Main items',
    },
    {
        segment: 'Dashboard',
        title: 'Dashboard',
        icon: <DashboardIcon />,
    },
    {
        kind: 'divider',
    },
    {
        kind: 'header',
        title: 'Features',
    },
    {
        segment: 'Calendar',
        title: 'Calendar',
        icon: <CalendarMonthIcon />,
    },
    {
        segment: 'Notes',
        title: 'Notes',
        icon: <NotesIcon />,
    },
    {
        segment: 'Todo',
        title: 'Todo',
        icon: <FormatListBulletedIcon />,
    },
    {
        segment: 'Shoppinglist',
        title: 'Shopping-List',
        icon: <ShoppingCartIcon />,
    },
    {
        segment: 'Weather',
        title: 'Weather',
        icon: <ThermostatIcon />,
    },
    {
        kind: 'divider',
    },
    {
        kind: 'header',
        title: 'Analytics',
    },
];

const customTheme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    default: '#f5e5e5',
                    paper: '#d4b8d4',
                },
                primary: {
                    main: '#5F0062',
                }
            },
        },
        // dark: {
        //     palette: {
        //         background: {
        //             default: '#761283',
        //             paper: '#330B33',
        //         },
        //     },
        // },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 600,
            lg: 1200,
            xl: 1536,
        },
    },
});

export default function DashboardLayoutBasic(props: any) {
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    async function signOut() {
        const { error } = await supabase.auth.signOut()
    }

    useEffect(() => {
        setLoading(true); // Ladezustand setzen, wenn die URL sich ändert
        const timer = setTimeout(() => {
            setLoading(false); // Ladezustand nach dem Laden aufheben
        }, 500); // Die Dauer des Ladezustands kann je nach Bedarf angepasst werden

        return () => clearTimeout(timer); // Timer bereinigen
    }, [location.pathname]);

    const [session, setSession] = useState(null)
    const [open, setOpen] = React.useState(true);
    const [alert, setAlert] = useState<JSX.Element | null>(null);

    const authentication = React.useMemo(() => {
        return {
            signIn: () => {
                supabase.auth.getSession().then(({ data: { session } }) => {
                    setSession(session)
                });
            },
            signOut: () => {
                supabase.auth.getSession().then(({ data: { session } }) => {
                    setSession(null)
                    signOut().then(r => setAlert(
                        <Collapse in={open}>
                            <Alert
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                            setOpen(false);
                                            setAlert(null);
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                sx={{ mb: 2 }}
                                severity={"success"}
                            >
                                <AlertTitle>Success</AlertTitle>
                                You have been signed out!
                            </Alert>
                        </Collapse>
                    ))
                })
            },
        };
    }, []);


    useEffect(() => {
        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session)
        })

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session)
        })

        return () => subscription.unsubscribe()
    }, [])


    if (session) {
        return (
            <ReactRouterAppProvider
                navigation={NAVIGATION}
                theme={customTheme}
                branding={{
                    logo: <img src="/Pictures/Logo.png" alt="Cat Logo" height={"auto"} width={"auto"} />,
                    title: 'Home-App',
                    homeUrl: '/',
                }}
                session={session}
                authentication={authentication}
            >
                <DashboardLayout>
                    <PageContainer style={{width:'auto', height:'auto'}}>
                        <Outlet/>
                    </PageContainer>
                </DashboardLayout>
            </ReactRouterAppProvider>
        );
    } else {
        return (
            <AppProvider
                theme={customTheme}
                branding={{
                    logo: <img src="/Pictures/Logo.png" alt="Cat Logo" height={"auto"} width={"auto"}/>,
                    title: 'Home-App',
                    homeUrl: '/',
                }}
            >
                <PageContainer>
                    {alert}
                    <Login/>
                </PageContainer>
            </AppProvider>

        )

    }
}